import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { XOE_POPUP_Z_INDEX } from '../../components/xoe/xoeLayout';

const DELETE_CONVERSATION_TITLE = 'Delete conversation';
const DELETE_CONVERSATION_CONTENT =
	'This conversation and its messages will be permanently deleted. This action cannot be undone.';

// The one delete confirm for every Xoe host; antd's default z (1000) would sit under the floating frame.
export const confirmDeleteConversation = (onOk: () => unknown): void => {
	Modal.confirm({
		title: DELETE_CONVERSATION_TITLE,
		icon: <ExclamationCircleOutlined />,
		content: DELETE_CONVERSATION_CONTENT,
		okText: 'Delete',
		okType: 'danger',
		cancelText: 'Cancel',
		zIndex: XOE_POPUP_Z_INDEX,
		onOk: () => onOk(),
	});
};
